import { combineReducers } from 'redux';

import Controller from '../../utils/Controller';
import SweetAlertReducer from '../Components/SweetAlert/reducer';
import RecorderReducer from '../Components/Record/Stores/Recorder';

export default class RecordController extends Controller {
  async record() {
    const reducers = {
      sweetAlert: SweetAlertReducer,
      recorder: RecorderReducer,
    };

    const store = await this.configureStore({
      reducers,
      combineReducers,
    });

    return store;
  }
}
